import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private toastr: ToastrService, private loggingService: LoggingService) { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dangerToast(message: string, error?: any) {
    const options = {
      disableTimeOut: true,
      tapToDismiss: true,
      closeButton: false,
      positionClass: 'toast-bottom-right',
      titleClass: 'toast-error-title',
      messageClass: 'toast-error-message'
    };

    let toastMessage = '';
    if (error && error.error) {
      if (error.error.Message) {
        toastMessage = `${message} - ${error.error.Message}`;
      } else {
        toastMessage = `${message} - ${error.error}`;
      }
    } else if (error && error.message) {
      toastMessage = `${message} - ${error.message}`;
    } else if (error) {
      toastMessage = `${message} - ${error}`;
    } else {
      toastMessage = message;
    }

    if (toastMessage.length > 400) {
      toastMessage = toastMessage.substring(0, 400);
    }
    this.toastr.error(toastMessage, 'Error', options);
    
    if (typeof error === 'undefined') {
      error = {
        message: toastMessage,
        stack: JSON.stringify(error)
      };
    } else {
      error.message = toastMessage;
      error.stack = JSON.stringify(error);
    }

    this.loggingService.logError(error);
  }

  warningToast(message: string, displayTime?: number) {
    const options = {
      disableTimeOut: false,
      timeOut: displayTime || 10000,
      tapToDismiss: true,
      closeButton: false,
      positionClass: 'toast-bottom-right',
      titleClass: 'toast-warning-title',
      messageClass: 'toast-warning-message'
    };

    this.toastr.warning(message, 'Warning', options);
  }

  successToast(message: string, displayTime?: number) {
    const options = {
      disableTimeOut: false,
      timeOut: displayTime || 5000,
      tapToDismiss: true,
      closeButton: false,
      positionClass: 'toast-bottom-right',
      titleClass: 'toast-success-title',
      messageClass: 'toast-success-message'
    };

    this.toastr.success(message, 'Success', options);
  }

  infoToast(message: string, title? : string, displayTime?: number) {
    const options = {
      disableTimeOut: false,
      timeOut: displayTime || 5000,
      tapToDismiss: true,
      closeButton: false,
      positionClass: 'toast-bottom-right',
      titleClass: 'toast-info-title',
      messageClass: 'toast-info-message'
    };

    this.toastr.info(message, title, options);
  }

  infoDescriptiveToast(message: string, title?: string, indicator?: string, displayTime?: number) {
    let toastClass = 'ngx-toastr toast-info';

    switch(indicator) {
      case 'G':
        toastClass = 'ngx-toastr toast-info-indicator-green'
        break;
      case 'A':
        toastClass = 'ngx-toastr toast-info-indicator-amber'
        break;
      case 'R':
        toastClass = 'ngx-toastr toast-info-indicator-red'
        break;
    }

    const options = {
      disableTimeOut: false,
      enableHtml: true,
      timeOut: displayTime || 5000, // success toasts have 5 second timeout
      tapToDismiss: true,
      closeButton: false,
      positionClass: 'toast-bottom-right',
      titleClass: 'toast-descriptive-title',
      messageClass: 'toast-descriptive-message',
      toastClass: toastClass
    };

    this.toastr.info(message, title, options);
  }

  clearToast() {
    this.toastr.clear();
  }
}
